import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";
import { displayErrorToast } from "@/utils/toast";

interface DeleteCustomModelPriceResponse {
  success: boolean;
}

export const useDeleteCustomModelPrice = (authToken: string, workspaceId: string | undefined) => {
  const queryClient = useQueryClient();

  return useMutation<DeleteCustomModelPriceResponse, Error, number>({
    mutationFn: async (priceId: number) => {
      const response = await fetch(
        ENDPOINTS.custom_model_prices.item(String(workspaceId), String(priceId)),
        {
          method: "DELETE",
          headers: jsonAuthHeaders(authToken),
        },
      );
      return handleResponse(response);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["customModelPrices", workspaceId] });
      queryClient.invalidateQueries({ queryKey: ["customModelPriceSuggestions", workspaceId] });
    },
    onError: (error: Error) => displayErrorToast(error.message),
  });
};
